import { Component, OnInit } from '@angular/core';
import { MensajeDmService } from '../../services/mensaje-dm.service';

@Component({
  selector: 'app-mensaje-dm',
  templateUrl: './mensaje-dm.component.html',
  styleUrls: ['./mensaje-dm.component.css']
})
export class MensajeDmComponent implements OnInit {
  mostrar = false;
  titulo = '';
  mensaje = '';

  constructor(private mensajeDmService: MensajeDmService) {}

  ngOnInit() {
    this.mensajeDmService.mostrarMensaje$.subscribe(show => {
      this.mostrar = show;
      if (show) {
        this.titulo = this.mensajeDmService.getTitulo();
        this.mensaje = this.mensajeDmService.getMensaje();
      }
    });
  }
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Components/mensaje-dm.component.ts